module.exports = __webpack_public_path__ + "img/tima2a.b694509c.png";